<template>
  <div class="page-container main">
    <el-button @click="backToList" class="back-button"></el-button>
    <el-container class="container">
      <el-aside width="360px">
        <el-tree
          v-if="visible"
          default-expand-all
          lazy
          :load="loadNode"
          ref="tree"
          icon-class="''"
          :highlight-current="true"
          node-key="localId"
          :props="defaultProps"
          @node-click="handleNodeClick"
          style="margin-right: 5px"
        >
          <div class="tree-node" slot-scope="{ node }">
            <div>
              <img src="@assets/arrow-down.svg" v-if="node.level === 1" style="width: 20px;height:20px" alt="">
              <img src="@assets/folder.svg" v-if="node.level === 2" style="width: 20px;height:20px" alt="">
              <img src="@assets/doctor.svg" v-if="node.level === 3" style="width: 20px;height:20px" alt="">
              {{ node.label }}
            </div>
            <div>
              <img src="@assets/icon-add.png" class="tree-icon" alt="" v-if="node.level === 1"
                   @click="e => handleAdd(e, node)">
              <img src="@assets/icon-del.png" class="tree-icon" alt=""
                   v-if="node.level === 2 && node.data.create_user === 0" @click="e => handleDel(e, node)">
              <img src="@assets/icon-del.png" class="tree-icon" alt=""
                   v-if="node.level === 3 && node.data.create_user === 0" @click="e => handleDel(e, node)">
            </div>
          </div>
        </el-tree>
      </el-aside>
      <el-container class="detail-content">
        <div class="qrcode" v-if="level === 2">
          <canvas ref="canvas" width="295px" height="442px"></canvas>
          <canvas ref="canvasQr" width="180px" height="180px" style="display: none;"></canvas>

          <canvas id="canvasDown" width="1180px" height="1768px" ref="canvasDown" style="display: none;"></canvas>
          <canvas ref="canvasDownQr" width="720px" height="720px"
                  style="display: none;"></canvas>
          <!--          <img :src="qrcode" style="width: 100px;height: 100px" alt="">-->
          <div class="text">
            <el-button type="primary" size="mini" @click="saveQrImg">点击下载</el-button>
          </div>
        </div>
        <el-form
          size="small"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="form">
          <template v-if="level === 1">
            <el-form-item label="省/市" prop="provinceCity">
              <el-cascader disabled :props="cascaderProps" :options="options" v-model="ruleForm.provinceCity"
                           clearable></el-cascader>
            </el-form-item>
            <el-form-item label="医院" prop="hospitalName">
              <!-- <el-input v-if="pageType === 'edit'" v-model="ruleForm.hospitalName" disabled></el-input> -->
              <template>{{ ruleForm.hospitalName }}</template>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.note" type="textarea"></el-input>
              <template v-else>{{ ruleForm.hospitalName }}</template>
            </el-form-item>
            <el-form-item v-if="pageType === 'edit'">
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="handleCancle">取消</el-button>
            </el-form-item>
          </template>
          <template v-else-if="level === 2">
            <el-form-item label="医院" prop="name">
              <el-input :readonly="true" class="readonly" v-model="hospitalName"></el-input>
            </el-form-item>
            <el-form-item label="科室" prop="departmentName">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.departmentName"></el-input>
              <template v-else>{{ ruleForm.departmentName }}</template>
            </el-form-item>
            <el-form-item label="科室类型" prop="departmentType">
              <el-select v-model="ruleForm.departmentType" placeholder="请选择" :disabled="pageType !== 'edit'">
                <el-option
                  v-for="item in depTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <!--              <el-input v-if="pageType === 'edit'" v-model="ruleForm.departmentType"></el-input>-->
              <!--              <template v-else>{{ ruleForm.departmentType }}</template>-->
            </el-form-item>
            <el-form-item label="科室缩写" prop="orderAbbr">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.orderAbbr"></el-input>
              <template v-else>{{ ruleForm.orderAbbr }}</template>
            </el-form-item>
            <el-form-item label="科室负责人姓名" prop="doctorName">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.doctorName"></el-input>
              <template v-else>{{ ruleForm.doctorName }}</template>
            </el-form-item>
            <el-form-item label="科室负责人电话" prop="mobile">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.mobile"></el-input>
              <template v-else>{{ ruleForm.mobile }}</template>
            </el-form-item>
            <el-form-item label="登录别名" prop="loginName">
              <el-tooltip content="医生账号登录别名(可选)" placement="right">
                <span v-if="pageType === 'edit'" >
                  <el-input v-model="ruleForm.loginName"></el-input>
<!--                  <el-button type="primary" @click="generateLoginName()">生成别名</el-button>-->
                </span>
                <template v-else>{{ ruleForm.loginName }}</template>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="3D查看器" prop="displayViewer" v-if="isAdmin">
              <el-select v-model="ruleForm.displayViewer" placeholder="请选择" :disabled="pageType !== 'edit'" style="width: 150px;" @change="onChangeDisplayViewer">
                <el-option
                  v-for="item in stl3dViewers"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="3D参数" v-if="isAdmin">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.displayMode" ></el-input>
              <template v-else>{{ ruleForm.displayMode }}</template>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.email"></el-input>
              <template v-else>{{ ruleForm.email }}</template>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input v-if="pageType === 'edit'" v-model="ruleForm.note" type="textarea"></el-input>
              <template v-else>{{ ruleForm.note }}</template>
            </el-form-item>

            <el-form-item label="代理商信息" prop="note">
              <!--              <el-input v-if="pageType === 'edit'" v-model="ruleForm.note" type="textarea"></el-input>-->
              <el-input v-model="ruleForm.agentName" disabled></el-input>
              <!--              <template>{{ ruleForm.agentName }}</template>-->
            </el-form-item>

            <el-form size="small" ref="payForm" :inline="true" :model="ruleForm" v-if="actionType === 'edit'"
                     :style="{width: 800+'px'}">
              <el-divider content-position="left" class="dep-divider">收费项目</el-divider>
              <div
                v-for="(payItem, index) in ruleForm.payItems"
                :key="payItem.key"
              >
                <el-form-item label="名称" label-width="100px" :prop="'payItems.' + index + '.name'"
                              :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                  <el-input v-model="payItem.name" :style="{width: 104+'px'}"></el-input>
                </el-form-item>
                <el-form-item label="终端价格" :prop="'payItems.' + index + '.price'"
                              :rules="{required: true, message: '金额不能为空', trigger: 'blur'}">
                  <el-input-number v-model="payItem.price" :precision="2" :step="0.1" :min="0" :controls=false
                                   :style="{width: 80+'px'}"></el-input-number>
                </el-form-item>
                <el-form-item label="代理商价格" :prop="'payItems.' + index + '.agentPrice'"
                              :rules="{required: false, message: '', trigger: 'blur'}">
                  <el-input-number v-model="payItem.agentPrice" :precision="2" :step="0.1" :min="0" :controls=false
                                   :style="{width: 80+'px'}"></el-input-number>
                </el-form-item>

                <el-form-item label="描述">
                  <el-input v-model="payItem.desc" :style="{width: 150+'px'}"></el-input>
                </el-form-item>
                <el-button size="small" type="primary" @click="savePayItem(payItem)">保存</el-button>
                <el-button size="small" @click.prevent="removePayItem(payItem)" v-if="ruleForm.payItems.length > 1">删除
                </el-button>
                <el-divider class="dep-divider dep-inner-divider"></el-divider>
              </div>
              <el-form-item label=" " label-width="100px">
                <el-button icon="el-icon-plus" size="mini" type="primary" @click="addPayItem">添加收费项目</el-button>
              </el-form-item>
              <el-divider class="dep-divider"></el-divider>
            </el-form>
            <el-form size="small" ref="payForm" :inline="true" :model="ruleForm" v-if="actionType === 'add'"
                     :style="{width: 800+'px'}">
              <el-divider content-position="left" class="dep-divider">收费项目</el-divider>
              <div
                v-for="(payItem, index) in ruleForm.payItems"
                :key="payItem.key"
              >
                <el-form-item label="名称" label-width="100px" :prop="'payItems.' + index + '.name'"
                              :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                  <el-input v-model="payItem.name" :style="{width: 104+'px'}"></el-input>
                </el-form-item>
                <el-form-item label="终端价格" :prop="'payItems.' + index + '.price'"
                              :rules="{required: true, message: '金额不能为空', trigger: 'blur'}">
                  <el-input-number v-model="payItem.price" :precision="2" :step="0.1" :min="0" :controls=false
                                   :style="{width: 80+'px'}"></el-input-number>
                </el-form-item>
                <el-form-item label="代理商价格" :prop="'payItems.' + index + '.agentPrice'"
                              :rules="{required: false, message: '', trigger: 'blur'}">
                  <el-input-number v-model="payItem.agentPrice" :precision="2" :step="0.1" :min="0" :controls=false
                                   :style="{width: 80+'px'}"></el-input-number>
                </el-form-item>
                <el-form-item label="描述">
                  <el-input v-model="payItem.desc" :style="{width: 150+'px'}"></el-input>
                </el-form-item>
                <el-button size="small" @click.prevent="removePayItem(payItem)" v-if="ruleForm.payItems.length > 1">移除
                </el-button>
                <el-divider class="dep-divider dep-inner-divider"></el-divider>
              </div>
              <el-form-item label=" " label-width="100px">
                <el-button icon="el-icon-plus" size="mini" type="primary" @click="addPayItem">添加收费项目</el-button>
              </el-form-item>
              <el-divider class="dep-divider"></el-divider>
            </el-form>
            <el-form-item v-if="pageType === 'edit'">
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="handleCancle">取消</el-button>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="医院" prop="name">{{ hospitalName }}</el-form-item>
            <el-form-item label="科室" prop="departmentName">{{ ruleForm.departmentName }}</el-form-item>
            <!--            <el-form-item label="科室类型" prop="departmentType">-->
            <!--              {{ depTypeList.filter(d => d.id === ruleForm.departmentType) }}-->
            <!--            </el-form-item>-->
            <el-form-item label="科室缩写" prop="order_abbr">{{ ruleForm.order_abbr }}</el-form-item>
            <el-form-item label="医生姓名" prop="doctor_name">
              {{ ruleForm.doctor_name }}
            </el-form-item>
            <el-form-item label="电话" prop="mobile">
              {{ ruleForm.mobile }}
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              {{ ruleForm.email }}
            </el-form-item>
            <el-form-item label="微信" prop="wechat">
              {{ ruleForm.wechat }}
            </el-form-item>
            <el-form-item label="备注" prop="note">
              {{ ruleForm.note }}
            </el-form-item>
          </template>
        </el-form>
      </el-container>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="300px">
      <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
        请输入安全密码：
        <el-input type="password" style="width: 140px" v-model="verify"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verify = '';dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="delVisible" width="300px">
      <div class="del-title">删除后不可恢复，是否删除此{{ level === 2 ? '科室' : '医生' }}？</div>
      <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
        请输入安全密码：
        <el-input type="password" style="width: 140px" v-model="verify"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verify = '';delVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDelSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {task as taskApi} from '@/api';
import {areas} from '@/utils/areas';
import QrCodeWithLogo from 'qr-code-with-logo';
import bg from '@/assets/department/bg.png';
import bgX2 from '@/assets/department/bg_x2.png';
import logo from '@/assets/department/logo.png';
import logoX2 from '@/assets/department/logo_x2.png';
import logoTxt from '@/assets/department/logo_txt.png';
import logoTxtX2 from '@/assets/department/logo_txt_x2.png';
import {isAdmin, isAgent, isCaptain, isWorker, isDoc} from '@/utils';
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState('common', ['userInfo']),
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    isCaptain() {
      const {role} = this.userInfo;
      return isCaptain(role);
    },
    isWorker() {
      const {role} = this.userInfo;
      return isWorker(role);
    },
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    }
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      // if (!/^1[3456789]\d{9}$/.test(value)) {
      //   callback(new Error('电话号码为数字'));
      //   return;
      // }
      callback();
    };
    return {
      console: console,
      visible: true,
      qrcode: '',
      dialogVisible: false,
      delVisible: false,
      verify: '',
      pageNo: 1,

      defaultProps: {
        children: 'sub',
        label: 'name'
      },

      options: areas,

      stl3dViewers: [
        { label: '默认(新版)',
          value: null},
        { label: '2022版',
          value: 'jz1'},
        { label: 'BETA测试版',
          value: 'test'}
      ],

      cascaderProps: {
        value: 'code',
        label: 'name'
      },

      ruleForm: {
        gender: '1',
        name: '',
        doctorId: '',
        doctorName: '',
        localId: '',
        provinceCity: [],
        wechat: '',
        mobile: '',
        loginName: '',
        displayViewer: '',
        displayMode: '',
        hospitalName: '',
        departmentName: '',
        departmentType: '',
        email: '',
        note: '',
        agentName: '',
        orderAbbr: '',
        payItems: []
      },
      defaultPayItems: [
        {
          key: 0,
          id: undefined,
          departmentId: undefined,
          name: undefined,
          price: undefined,
          agentPrice: undefined,
          desc: undefined
        }
      ],
      rules: {
        name: [{message: '请输入姓名', trigger: 'blur'}],
        hospitalName: [
          {required: true, message: '请输入医院名称', trigger: 'blur'}
        ],
        departmentName: [
          {required: true, message: '请输入科室名称', trigger: 'blur'}
        ],
        gender: [{required: true, message: '请选择性别', trigger: 'change'}],
        doctorName: [
          {required: true, message: '请输入医生姓名', trigger: 'blur'}
        ],
        provinceCity: [
          {
            type: 'array',
            required: true,
            message: '请选择省市',
            trigger: 'change'
          }
        ],
        localId: [{required: true, message: '请选择医院', trigger: 'change'}],
        mobile: [
          {required: true, message: '请选输入电话', trigger: 'blur'},
          {validator: validateMobile, trigger: 'blur'}
        ],
        wechat: [{message: '请选输入微信号', trigger: 'blur'}],
        email: [{message: '请输入电子邮件', trigger: 'blur'}],
        note: [{message: '请输入备注', trigger: 'blur'}],
        orderAbbr: [
          {required: true, message: '请输入科室缩写', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let patt = /^[a-zA-Z]{2}$/;
              if (!patt.test(value)) {
                callback(new Error('限定2个字母'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },

      hospitalTreeList: [],
      provinceCity: [],
      hospitalList: [],
      depTypeList: [
        {id: 0, name: '肝胆外科'},
        {id: 1, name: '胸外科'},
        {id: 2, name: '泌尿外科'},
        {id: 3, name: '妇科'},
        {id: 4, name: '耳鼻喉科'},
        {id: 5, name: '头颈外科'},
        {id: 6, name: '胃肠外科'},
        {id: 7, name: '颅脑科'},
        {id: 9, name: '默认'},
      ],

      level: 2,
      localId: '',
      mobile: '',

      hospitalId: '',
      hospitalName: '',
      name: '',
      pageType: 'edit',
      actionType: 'edit',
      departmentId: undefined,
      payFormValid: false
    };
  },
  methods: {
    backToList() {
      this.$router.back();
    },
    addPayItem() {
      this.ruleForm.payItems.push({
        name: undefined,
        price: undefined,
        agentPrice: undefined,
        desc: undefined,
        key: Date.now()
      });
    },
    removePayItem(payItem) {
      let index = this.ruleForm.payItems.indexOf(payItem);
      if (index !== -1) {
        if (payItem.id) {
          taskApi.deletePayItem(payItem.id).then(res => {
            if (res.code === 10000) {
              this.$message.success('操作成功！');
              this.ruleForm.payItems.splice(index, 1);
            }
          });
        } else {
          this.ruleForm.payItems.splice(index, 1);
        }
      }
    },
    savePayItem(payItem) {
      if (payItem.id) {
        taskApi.updatePayItem({...payItem}).then(res => {
          if (res.code === 10000) {
            this.$message.success('操作成功！');
          }
        });
      } else {
        taskApi.addPayItem({
          name: payItem.name,
          price: payItem.price,
          agentPrice: payItem.agentPrice,
          desc: payItem.desc,
          departmentId: this.departmentId
        }).then(res => {
          if (res.code === 10000) {
            this.$message.success('操作成功！');
          }
        });
      }
    },
    handleRefreshTree() {
      this.visible = false;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    handleAdd(e, node) {
      e.stopPropagation();
      this.actionType = 'add';
      this.level = 2;
      this.ruleForm = {
        name: '',
        departmentLocalId: this.localId || this.departmentId,
        localId: this.hospitalId,
        mobile: '',
        email: '',
        docName: '',
        payItems: this.defaultPayItems
      };
    },
    handleDel(e, {data}) {
      e.stopPropagation();
      this.level = data.level;
      this.localId = data.localId;
      this.delVisible = true;
    },
    handleDelSubmit() {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi[this.level === 2 ? 'departmentDelete' : 'doctorDelete']({
        localId: this.localId,
        verify: this.verify
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('删除成功！');
          this.handleRefreshTree();
        } else {
          this.verify = '';
        }
      });
    },
    handleCancle() {
      this.resetForm('ruleForm');
    },
    handleSubmit() {
      if (this.verify) {
        this.dialogVisible = false;
        this.submitForm('ruleForm');
      } else {
        this.$message.error('请输入安全密码！');
      }
    },
    handleNodeClick({localId, level}) {
      this.localId = localId;
      this.level = level;
      this.actionType = 'edit';
      if (level === 1) {
        this.hospitalDetail();
      } else if (level === 2) {
        this.departmentDetail();
      } else {
        this.doctorDetail();
      }
    },
    hospitalDetail() {
      taskApi
        .hospitalDetail({
          local_id: this.hospitalId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.ruleForm.provinceCity = [String(data.provinceId), String(data.cityId)];
            this.ruleForm.hospitalName = data.name;
            this.ruleForm.note = data.note;
          }
        });
    },
    hospitalEdit() {
      taskApi[this.actionType === 'edit' ? 'hospitalUpdate' : 'hospitalAdd']({
        name: this.ruleForm.hospitalName,
        namprovinceCitye: this.ruleForm.provinceCity,
        note: this.ruleForm.note
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作成功！');
          this.handleRefreshTree();
        }
      });
    },
    departmentDetail(departmentLocalId) {
      taskApi.departmentDetail({
        local_id: departmentLocalId || this.localId || this.departmentId
      }).then(res => {
        if (res.code === 10000) {
          const {data} = res;
          this.ruleForm.doctorId = data.doctorLocalId;
          this.ruleForm.departmentName = data.name;
          this.ruleForm.departmentType = data.type;
          this.ruleForm.orderAbbr = data.orderAbbr;
          this.ruleForm.doctorName = data.doctorName;
          this.ruleForm.mobile = data.mobile;
          this.ruleForm.loginName = data.loginName;
          try {
            this.ruleForm.displayMode = data.displayMode;
            this.ruleForm.displayViewer = null;
            let dp = JSON.parse(this.ruleForm.displayMode);
            if (dp) {
              this.ruleForm.displayViewer = dp.viewer;
            }
          } catch (e) {
          }
          this.mobile = data.mobile;
          this.ruleForm.email = data.email;
          this.ruleForm.note = data.note;
          this.ruleForm.agentName = data.agentName;
          this.qrcode = `https://s3.truesight.com.cn/${data.qrcode}`;
          this.createQr(data, 0);
          this.departmentId = data.id;
          this.departmentLocalId = data.localId;
          taskApi.payItemList(data.id).then(res => {
            if (res.code === 10000 && res.data.length) {
              this.ruleForm.payItems = res.data.map(item => {
                return {...item, key: item.id};
              });
            } else {
              this.ruleForm.payItems = this.defaultPayItems;
            }
          });
        }
      });
    },
    // 创建qr
    createQr(data) {
      if (!data.departmentMaQr) {
        console.error('departmentMaQr is NULL');
        return;
      }
      QrCodeWithLogo.toCanvas({
        canvas: this.$refs.canvasQr,
        content: data.departmentMaQr,
        width: 185,
        nodeQrCodeOptions: {
          margin: 2,
        },
        logo: {
          src: logo,
          logoSize: 0.25,
          logoRadius: 3,
          borderRadius: 10,
          bgColor: 'transparent'
        }
      }).then(_ => {
        const canvases = this.$refs.canvas;
        const qrCanvas = this.$refs.canvasQr;
        this.loadQr(canvases, qrCanvas, 0);
      });

      QrCodeWithLogo.toCanvas({
        canvas: this.$refs.canvasDownQr,
        content: data.departmentMaQr,
        width: 185 * 4,
        nodeQrCodeOptions: {
          margin: 2,
        },
        logo: {
          src: logoX2,
          logoSize: 0.25,
          logoRadius: 3,
          borderRadius: 10,
          bgColor: 'transparent'
        }
      }).then(_ => {
        const canvases = this.$refs.canvasDown;
        const qrCanvas = this.$refs.canvasDownQr;
        this.loadQr(canvases, qrCanvas, 1);
      });
    },
    // 绘制二维码
    loadQr(canvases, qrCanvas, type) {
      // let canvas = type === 0 ? this.$refs.canvas : this.$refs.canvasDown;
      let ctx = canvases.getContext('2d');
      const that = this;
      let width = type === 0 ? 295 : 295 * 4;
      let height = type === 0 ? 442 : 442 * 4;
      let bGHeight = type === 0 ? 110 : 110 * 4;
      let qrSize = type === 0 ? 190 : 190 * 4;
      let logoTxtWidth = type === 0 ? 230 : 230 * 4;
      let logoTxtHeight = type === 0 ? 30 : 30 * 4;

      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      // 顶部背景
      let backImg = new Image();
      backImg.src = type === 0 ? bg : bgX2;
      backImg.onload = function() {
        // that.drawRadius(ctx, 0, 0, width, bGHeight, 12, true, true, false, false);
        // ctx.clip();
        // console.log(backImg.src);
        // console.log(bGHeight);
        ctx.drawImage(backImg, 0, 0, width, bGHeight);
        ctx.fillStyle = '#ffffff';
        let fontSize = that.hospitalName.length > 12 ? 16 : 18;
        // 医院
        ctx.font = (type === 0 ? fontSize : fontSize * 4) + 'px webfont'; // 设置文字大小
        let hospitalName = '';
        if (that.hospitalName && that.hospitalName.length < 12) {
          let nameArr = that.hospitalName.split('');
          for (let i = 0; i < nameArr.length; i++) {
            hospitalName += nameArr[i] + ' ';
          }
        } else {
          hospitalName = that.hospitalName;
        }
        ctx.fillText(hospitalName || '--', width / 2, type === 0 ? 35 : 35 * 4);
        // 科室
        let departmentName = '';
        let depArr = that.ruleForm.departmentName.split('#')[0].split('');
        for (let i = 0; i < depArr.length; i++) {
          departmentName += depArr[i] + ' ';
        }
        ctx.font = (type === 0 ? 18 : 18 * 4) + 'px webfont';
        ctx.fillText(departmentName, width / 2, type === 0 ? 65 : 65 * 4);
      };

      // 白色矩形
      ctx.textBaseline = 'top';
      console.log(bGHeight);
      console.log(width);
      console.log(height - bGHeight);
      ctx.fillRect(0, bGHeight, width, height - bGHeight);

      // 二维码
      let qrImg = new Image();
      qrImg.src = qrCanvas.toDataURL('image/png');
      qrImg.onload = function() {
        ctx.drawImage(qrImg, (width - qrSize) / 2, bGHeight + (type === 0 ? 30 : 30 * 4), qrSize, qrSize);
        // 微信扫一扫
        ctx.fillStyle = '#000000';
        ctx.font = (type === 0 ? 13 : 13 * 4) + 'px Calibri';
        ctx.fillText('微信扫一扫，填写订单并支付', width / 2, bGHeight + qrSize + (type === 0 ? 28 : 28 * 4));
      };

      ctx.fillStyle = '#ffffff';
      // 虚线
      // ctx.setLineDash([4, 4]);
      // ctx.lineWidth = 1;
      // ctx.strokeStyle = '#E6E6E6';
      // ctx.beginPath();
      // ctx.moveTo(32, height - logoTxtHeight * 3 + (type === 0 ? 20 : 30));
      // ctx.lineTo(width - 32, height - logoTxtHeight * 3 + (type === 0 ? 20 : 30));
      // ctx.stroke();
      // 底部logo
      let logoImg = new Image();
      logoImg.src = type === 0 ? logoTxt : logoTxtX2;
      logoImg.onload = function() {
        ctx.drawImage(logoImg, (width - logoTxtWidth) / 2, height - logoTxtHeight * 2.4, logoTxtWidth, logoTxtHeight);
      };
      // 如果科室名字包含有#，把#后面的文字以浅白色显示在二维码右下角
      let extName = that.ruleForm.departmentName.split('#');
      if (extName.length === 2) {
        extName = '#' + extName[1];
        let fontSize = (type === 0 ? 18 : 18 * 4);
        ctx.fillStyle = '#EEE';
        ctx.font = fontSize + 'px Calibri';
        ctx.fillText(extName, width - fontSize * extName.length / 2, height - fontSize * 1.5);
      }
    },

    /**
     * 下载二维码
     */
    saveQrImg() {
      const canvas = document.getElementById('canvasDown');
      const a = document.createElement('a');
      // a.href = canvasData[0].src;
      a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
      a.download = this.hospitalName + ' - ' + this.ruleForm.departmentName + ' 收费码.png';
      a.click();
    },
    onChangeDisplayViewer(viewerName) {
      let dp = {};
      try {
        dp = JSON.parse(this.ruleForm.displayMode) || {};
      } catch (e) {
      }
      if (viewerName) {
        dp.viewer = viewerName;
      } else {
        delete dp.viewer;
      }
      this.ruleForm.displayMode = JSON.stringify(dp);
    },
    departmentEdit() {
      taskApi[this.actionType === 'edit' ? 'departmentUpdate' : 'departmentAdd']({
        name: this.ruleForm.departmentName,
        type: this.ruleForm.departmentType,
        id: this.localId || this.departmentId,
        departmentLocalId: this.localId || this.departmentId,
        localId: this.hospitalId,
        doctorLocalId: this.ruleForm.doctorId,
        mobile: String(this.ruleForm.mobile),
        loginName: String(this.ruleForm.loginName),
        displayMode: this.ruleForm.displayMode,
        email: this.ruleForm.email,
        docName: this.ruleForm.doctorName,
        // order_abbr: String(+new Date()),
        orderAbbr: this.ruleForm.orderAbbr,
        note: this.ruleForm.note,
        changeMode: String(this.ruleForm.mobile) === this.mobile ? '' : '1',
        item: this.ruleForm.payItems.map(item => {
          return {name: item.name, price: item.price, agentPrice: item.agentPrice, desc: item.desc};
        }),
        verify: String(this.verify)
      }).then(res => {
        if (res.code === 10000) {
          this.handleRefreshTree();
          this.$message.success('操作成功！');
          this.departmentDetail(this.departmentLocalId);
        } else {
          this.verify = '';
        }
      });
    },
    doctorDetail() {
      taskApi
        .doctorDetail({
          localId: this.localId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.ruleForm.hospitalName = data.hospitalName;
            this.ruleForm.departmentName = data.departmentName;
            this.ruleForm.departmentType = data.departmentType;
            this.ruleForm.order_abbr = data.orderAbbr;
            this.ruleForm.note = data.note;
            this.ruleForm.email = data.email;
            this.ruleForm.wechat = data.wechat;
            this.ruleForm.mobile = data.mobile;
            this.ruleForm.doctor_name = data.name;
          }
        });
    },
    doctorEdit() {
      taskApi[this.actionType === 'edit' ? 'doctorUpdate' : 'doctorAdd']({
        hospitalName: this.ruleForm.hospitalName,
        departmentName: this.ruleForm.departmentName,
        departmentType: this.ruleForm.departmentType,
        orderAbbr: this.ruleForm.orderAbbr,
        email: this.ruleForm.email,
        wechat: this.ruleForm.wechat,
        name: this.ruleForm.name,
        mobile: this.ruleForm.mobile,
        note: this.ruleForm.note
      }).then(res => {
        if (res.code === 10000) {
          this.handleRefreshTree();
          this.$message.success('操作成功！');
        }
      });
    },
    submitForm(formName) {
      this.level === 2 &&
      this.$refs['payForm'].validate(valid => {
        this.payFormValid = valid;
        return valid;
      });
      this.$refs[formName].validate(valid => {
        if (valid) {
          if ((!this.verify && this.level !== 2) || (!this.verify && this.level === 2 && this.mobile !== this.ruleForm.mobile)) {
            this.dialogVisible = true;
            return;
          }
          if (this.level === 1) {
            this.hospitalEdit();
          } else if (this.level === 2) {
            if (this.payFormValid) {
              this.departmentEdit();
            } else {
              return false;
            }
            this.payFormValid = false;
          } else {
            this.doctorEdit();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleHospital(value) {
      taskApi.hospitalListName({}).then(res => {
        if (res.code === 10000) {
          const {data} = res;
          this.hospitalList = data;
          this.ruleForm.localId = '';
        }
      });
    },
    async lazyLoad(node, resolve) {
      const {data} = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(
        data.map(e => ({
          value: e.code,
          label: e.name,
          leaf: e.level >= 2
        }))
      );
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.hospitalId) {
          const {data} = await taskApi.departmentHospitalList({
            localId: this.hospitalId
          });
          const hospitalTreeList = [data];
          hospitalTreeList.forEach(item => {
            item.level = 1;
            item.sub.forEach(e => {
              e.level = 2;
            });
          });
          this.hospitalTreeList = hospitalTreeList;
          return resolve(this.hospitalTreeList);
        }
      }
      if (node.level === 1) {
        return resolve(this.hospitalTreeList[0].sub);
      }
      if (node.level === 2) {
        const {code, data} = await taskApi.doctorDepartmentList({
          local_id: node.data.localId
        });
        if (code === 10000) {
          return resolve(
            data.map(e => ({name: e.name, localId: e.localId, level: 3, createUser: e.createUser}))
          );
        }
      }
      if (node.level > 2) return resolve([]);
    },
    initData() {
      this.departmentId = this.$route.params.id;
      this.hospitalId = this.$route.query.hospitalId;
      this.hospitalName = this.$route.query.hospitalName;
      this.pageType = this.$route.query.pageType;
      this.level = 2;
      this.ruleForm.payItems = this.defaultPayItems;
      this.pageNo = parseInt(this.$route.query.pageNo);
      this.departmentDetail();
    }
  },
  created() {
    this.initData();
  },
  beforeRouteLeave(to, from, next) {
    to.meta.pageNo = this.pageNo;
    next();
  }
};
</script>
<style scoped>
@font-face {
  font-family: 'webfont';
  font-display: swap;
  src: url('//at.alicdn.com/t/webfont_xwnt8s2i77.eot'); /* IE9*/
  src: url('//at.alicdn.com/t/webfont_xwnt8s2i77.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('//at.alicdn.com/t/webfont_xwnt8s2i77.woff2') format('woff2'),
  url('//at.alicdn.com/t/webfont_xwnt8s2i77.woff') format('woff'), /* chrome、firefox */ url('//at.alicdn.com/t/webfont_xwnt8s2i77.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('//at.alicdn.com/t/webfont_xwnt8s2i77.svg#思源黑体-粗') format('svg'); /* iOS 4.1- */
}

.tree-node {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.container {
  padding-top: 10px;
  min-height: calc(100vh - 64px);
  color: #fff;
}

.ruleForm {
  width: 304px;
}

.del-title {
  font-size: 16px;
  margin-bottom: 16px;
}

.detail-content {
  border-left: 1px solid #3E4451;
  padding-top: 10px;
  position: relative;
}

.qrcode {
  position: absolute;
  right: 20px;
  top: 32px;
  text-align: center;
}

.qrcode .text {
  font-size: 16px;
}

.back-button {
  position: fixed;
  top: 16px;
  left: 200px;
  background-color: rgba(221, 236, 255, 0.1);
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  padding: 0px;
  background-image: url('~@/assets/backto.png');
}

.dep-divider {
  background-color: #121820;
}

.dep-inner-divider {
  margin: 0px 0px 22px 60px;
  width: 728px;
}

.dep-divider .el-divider__text {
  background-color: #222933;
  color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/view/DepartmentEdit/index.vue